<template>
  <v-navigation-drawer
    :key="key"
    ref="drawer"
    class="drawer"
    :color="$vuetify.theme.themes.light.drawerBKColor"
    app
    expand-on-hover
    :permanent="checkResponsive"
    :mini-variant="mini"
    @update:mini-variant="resize_app_bar"
    right
    v-model="drawer"
  >
    <v-list-item class="ma-0 pa-0 d-logo-item" style="height: 56px">
      <v-img v-if="$store.state.mini" id="logo" contain src="@/assets/wasata.svg" />
      <v-img v-else @click="redirect" contain src="@/assets/main-logo.svg" />
      
    </v-list-item>
    
    <v-list dense s>
      <template v-for="entry in menuEntries">
      <v-list-group
        v-if="entry.type === 'group'"
        :key="entry.key"
        no-action
        @click="$store.state.mini ? ($store.state.mini = false) : undefined"
        v-model="entry.active"
      >
        <!-- <template v-slot:activator>
          <v-badge
            color="error support-c-1"
            dot
            v-if="entry.name == 'الطلبات' && $store.state.recievedCount > 0"
          >
            <v-list-item-icon
              class="align-center support-c-2"
              v-html="entry.icon"
            ></v-list-item-icon>
          </v-badge>
          <v-list-item-icon
            v-else
            class="ml-2 align-center"
            v-html="entry.icon"
          ></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              v-if="entry.name == 'الطلبات' && $store.state.recievedCount > 0"
              class="item-text-color"
              style="margin-right: 30px"
              >{{ entry.name }}</v-list-item-title
            >

            <v-list-item-title v-else class="item-text-color">{{
              entry.name
            }}</v-list-item-title>
          </v-list-item-content>
        </template> -->

        <template v-slot:activator>
          <v-badge
            color="error support-c-1"
            dot
            v-if="(entry.name === 'الطلبات' && $store.state.recievedCount > 0) || (entry.name === 'الطلبات .' && $store.state.count_of_received_requests_in_quality > 0)"
          >
            <v-list-item-icon class="align-center support-c-2" v-html="entry.icon"></v-list-item-icon>
          </v-badge>
          <v-list-item-icon
            v-else-if="entry.name === 'التذاكر' || entry.name === 'التذاكر ' ||  entry.name === 'التذاكـر' ||  entry.name === 'التذاكر .'"
            class="ml-2 align-center"
            v-html="entry.icon.replace('$iconColor', ticketIconColor)"
          ></v-list-item-icon>
          <v-list-item-icon
            v-else
            class="ml-2 align-center"
            v-html="entry.icon"
          ></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              v-if="entry.name === 'الطلبات' && $store.state.recievedCount > 0"
              class="item-text-color"
              style="margin-right: 30px"
            >
              {{ entry.name }}
            </v-list-item-title>
            <v-list-item-title v-else class="item-text-color">{{ entry.name }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="page in entryItems(entry)"
          :key="page.meta.page_name"
          :to="page.path"
          :target="page.meta.newTab ? '_blank' : ''"
          link
          class="pr-9"
        >
          <v-list-item-icon class="mx-0 px-0 align-center"
            ><v-icon style="color: white">mdi-menu-left</v-icon></v-list-item-icon
          >
          <v-list-item-title class="item-text-color" v-text="page.meta.page_name">
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === ' all' && countObj.all > 0"
            class="item-text-color showCount"
            v-text="SimplifyNumber(countObj.all)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'general' && countObj.general_requests_count > 0"
            class="item-text-color showCount"
            v-text="SimplifyNumber(countObj.general_requests_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'processing' && countObj.customer_services_requests_processed_count > 0"
            class="item-text-color showCount"
            v-text="SimplifyNumber(countObj.customer_services_requests_processed_count)"
          >
          </v-list-item-title>

          <v-list-item-title
            v-if="page.name === 'has_personal_request' && countObj.admin_has_personal_request_count > 0"
            class="item-text-color showCount"
            v-text="SimplifyNumber(countObj.admin_has_personal_request_count)"
          >
          </v-list-item-title>

          <v-list-item-title
            v-if="page.name === 'administration_requests' && countObj.admin_administration_request_count > 0"
            class="item-text-color showCount"
            v-text="SimplifyNumber(countObj.admin_administration_request_count)"
          >
          </v-list-item-title>

          <v-list-item-title
            v-if="page.name === 'funding_duration_average' && countObj.admin_funding_duration_requests_count > 0"
            class="item-text-color showCount"
            v-text="SimplifyNumber(countObj.admin_funding_duration_requests_count)"
          >
          </v-list-item-title>

          <v-list-item-title
            v-if="page.name === ' followed' && countObj.following_requests_count > 0"
            class="item-text-color showCount"
            style="background-color: #5097cc"
            v-text="SimplifyNumber(countObj.following_requests_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'featured' && countObj.stars_requests_count > 0"
            class="item-text-color showCount"
            style="background-color: #d89e01"
            v-text="SimplifyNumber(countObj.stars_requests_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === ' archieved' && countObj.archived_requests_count > 0"
            class="item-text-color showCount"
            style="background-color: #b1b0b1"
            v-text="SimplifyNumber(countObj.archived_requests_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === ' recieved' && countObj.received_requests_count > 0"
            class="item-text-color showCount"
            style="background-color: #d89e01"
            v-text="SimplifyNumber(countObj.received_requests_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'recieved' && $store.state.recievedCount > 0"
            class="item-text-color showCount"
            style="background-color: #f44336; width: 30px; height: 30px"
            v-text="SimplifyNumber($store.state.recievedCount)"
          >
          </v-list-item-title>

          <v-list-item-title
            v-if="page.name === 'quality_recieved' && $store.state.count_of_received_requests_in_quality > 0"
            class="item-text-color showCount"
            style="background-color: #f44336; width: 30px; height: 30px"
            v-text="SimplifyNumber($store.state.count_of_received_requests_in_quality)"
          >
          </v-list-item-title>

          <!-- Badge for recieved tasks notification count for agent and sales manager => Khaled -->
          <v-list-item-title
            v-if="(page.name === 'recieved_tickets' || page.name === 'salesManager_recieved_tickets' || page.name === 'admin_recieved_tickets' || page.name === 'quality_recieved_tickets') && $store.state.recieved_tasks_notifications_count > 0"
            class="item-text-color showCount"
            style="background-color: #f44336; width: 30px; height: 30px;left: 0;"
            v-text="SimplifyNumber($store.state.recieved_tasks_notifications_count)"
          >
          </v-list-item-title>

          <!-- <v-list-item-title v-if="page.name === 'recieved' &&  countObj.received_requests_count > 0"
                             class="item-text-color showCount" style="background-color: #f44336; width: 30px; height: 30px;"
                             v-text="SimplifyNumber(countObj.received_requests_count)">
          </v-list-item-title> -->
          <v-list-item-title
            v-if="page.name === 'pending' && countObj.additional_requests_count > 0"
            class="item-text-color showCount"
            style="background-color: #bb8ffe"
            v-text="SimplifyNumber(countObj.additional_requests_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'new' && countObj.need_actions_new_count > 0"
            class="item-text-color showCount"
            style="background-color: #73264d"
            v-text="SimplifyNumber(countObj.need_actions_new_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'done' && countObj.need_actions_done_count > 0"
            class="item-text-color showCount"
            style="background-color: #73264d"
            v-text="SimplifyNumber(countObj.need_actions_done_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'wating-new' && countObj.waiting_list_new_count > 0"
            class="item-text-color showCount"
            style="background-color: #d89e01"
            v-text="SimplifyNumber(countObj.waiting_list_new_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'wating-done' && countObj.freez_count > 0"
            class="item-text-color showCount"
            style="background-color: #d89e01"
            v-text="SimplifyNumber(countObj.waiting_list_done_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'latest' && countObj.latest_count > 0"
            class="item-text-color showCount"
            style="background-color: #d89e01"
            v-text="SimplifyNumber(countObj.latest_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="page.name === 'freeze' && countObj.waiting_list_done_count > 0"
            class="item-text-color showCount"
            style="background-color: #0f5a95"
            v-text="SimplifyNumber(countObj.freez_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="
              page.name === 'needToTurnDone' &&
              countObj.need_to_be_returned_done_count > 0
            "
            class="item-text-color showCount"
            style="background-color: #bb8ffe"
            v-text="SimplifyNumber(countObj.need_to_be_returned_done_count)"
          >
          </v-list-item-title>
          <v-list-item-title
            v-if="
              page.name === 'needToTurnNew' && countObj.need_to_be_returned_new_count > 0
            "
            class="item-text-color showCount"
            style="background-color: #bb8ffe; font-size: 10px"
            v-text="SimplifyNumber(countObj.need_to_be_returned_new_count)"
          >
          </v-list-item-title>
          <v-list-item-title
              v-if="
              page.name === 'duplicatedRequests' && countObj.duplicated_customer_negative_count > 0
            "
              class="item-text-color showCount"
              style="background-color: #bb8ffe; font-size: 10px"
              v-text="SimplifyNumber(countObj.duplicated_customer_negative_count)"
          >
          </v-list-item-title>
        </v-list-item>
        <!-- <v-list-item
          v-if="entry.name == 'الطلبات' && is_customer_service == '1'"
          :key="'cs_processing'"
          :to="'/agent/requests/cs-processing'"
          :target="''"
          link
          class="pr-9"
        >
          <v-list-item-icon class="mx-0 px-0 align-center"
            ><v-icon style="color: white">mdi-menu-left</v-icon></v-list-item-icon
          >
          <v-list-item-title class="item-text-color" v-text="'سلة العمليات '">
          </v-list-item-title>

        </v-list-item> -->
        <v-list-item
          v-if="entry.name == 'الطلبات' && is_customer_service == '1'"
          :key="'cs_completed'"
          :to="'/agent/requests/cs-completed'"
          :target="''"
          link
          class="pr-9"
        >
          <v-list-item-icon class="mx-0 px-0 align-center"
            ><v-icon style="color: white">mdi-menu-left</v-icon></v-list-item-icon
          >
          <v-list-item-title class="item-text-color" v-text="'المكتملة'">
          </v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-item
        v-else
        :key="entry.key"
        :to="entry.route.path"
        :target="entry.route.meta.newTab ? '_blank' : ''"
        link
      >
        <v-list-item-icon class="ml-2" v-html="getIcons(entry.route)"> </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="item-text-color" style="display: flex"
            >{{ entry.route.meta.page_name }}
            <span
              v-if="
                entry.route.meta.page_name === 'طلبات الدعم الفني' && $store.state.supportCount > 0
              "
              style="
                color: white;
                width: 30px;
                height: 30px;
                background: #017f85;
                border-radius: 50%;
                justify-content: center;
                display: flex;
                align-items: center;
                margin-right: 30px;
              "
              >{{ $store.state.supportCount }}</span
            >


            

            <!-- <span
              v-if="
                entry.route.meta.page_name === 'التذاكر المستلمة' && $store.state.recieved_tasks_notifications_count > 0
              "
              style="
                color: white;
                width: 30px;
                height: 30px;
                background: #017f85;
                border-radius: 50%;
                justify-content: center;
                display: flex;
                align-items: center;
                margin-right: 30px;
              "
              >{{ $store.state.recieved_tasks_notifications_count }}</span
            > -->

            <span
              v-if="
                entry.route.meta.page_name === 'التذاكر المستلمة' && $store.state.received_tasks_count > 0
              "
              style="
                color: white;
                width: 30px;
                height: 30px;
                background: #017f85;
                border-radius: 50%;
                justify-content: center;
                display: flex;
                align-items: center;
                margin-right: 30px;
              "
              >{{ $store.state.received_tasks_count }}</span
            >
            
            <!-- <span
              v-if="
                entry.route.meta.page_name === 'محادثات العملاء'
              "
              style="
                color: white;
                width: 30px;
                height: 30px;
                background: #017f85;
                border-radius: 50%;
                justify-content: center;
                display: flex;
                align-items: center;
                margin-right: 30px;
              "
              >{{ $store.state.navbarUnreadCountNum }}</span
            > -->

            <span
              v-if="
                (entry.route.meta.page_name === 'تقيمات الخدمه' || entry.route.meta.page_name === 'تقييمات الخدمة') && $store.state.rates_notifications_count > 0
              "
              style="
                color: white;
                width: 30px;
                height: 30px;
                background: #017f85;
                border-radius: 50%;
                justify-content: center;
                display: flex;
                align-items: center;
                margin-right: 30px;
              "
              >{{ $store.state.rates_notifications_count }}</span
            >

          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </template>
      <v-list-group
        v-for="group in filteredNavBarGroupsBottom"
        :key="group.name"
        no-action
        @click="$store.state.mini ? ($store.state.mini = false) : undefined"
        v-model="group.active"
      >
        <template v-slot:activator>
          <!-- <v-badge color="error support-c-1" dot v-if="$store.state.supportCount > 0">
            <v-list-item-icon
              class="align-center support-c-2"
              v-html="getNavBarGroupsBottomIcons(group.icon)"
            ></v-list-item-icon>
          </v-badge> -->

          <v-list-item-icon
            v-if="$store.state.supportCount > 0"
            class="align-center support-c-2"
            v-html="getNavBarGroupsBottomIcons(group.icon)"
          ></v-list-item-icon>

          <v-list-item-icon
            v-if="$store.state.supportCount == 0"
            class="ml-2 align-center support-c-3"
            v-html="getNavBarGroupsBottomIcons(group.icon)"
          ></v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="item-text-color" style="margin-right: 30px">{{
              group.name
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <TeckSupport
          v-if="(!techSupport || CurrentRole == 1) && group.name == 'طلبات الدعم الفني'"
        />
        <v-list-item
          v-for="page in entryItems(group)"
          :key="page.meta.page_name"
          :to="page.path"
          :target="page.meta.newTab ? '_blank' : ''"
          link
          class="pr-9"
        >
          <v-list-item-icon class="mx-0 px-0 align-center"
            ><v-icon style="color: white">mdi-menu-left</v-icon></v-list-item-icon
          >
          <v-list-item-title
            class="item-text-color"
            v-text="page.meta.page_name"
          ></v-list-item-title>
          <v-badge
            color="error"
            style="left: 16px; right: unset"
            :content="$store.state.supportCount"
            inline
          ></v-badge>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- <TeckSupport v-if="!techSupport" /> -->

   

    <v-list-item class="ma-0 pa-0 d-logo-item" style="height: 56px">
      <div id="sidebar">
        <button @click="scrollTo">
          <v-icon>{{ isAtBottom ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
        </button>
      </div>
    </v-list-item>

  </v-navigation-drawer>
</template>

<script>
import TeckSupport from "@/components/Dialogs/TechSupport.vue";
import Axios from "axios";
import { mapGetters } from "vuex";
import { SimplifyNumber } from "@/mixins/simplifyNumber";
import {
  getSupportIcon,
  getSupportIconDynamic,
  getTicketsReceivedIconDynamic,
  getServiceRatingsIconDynamic
} from "@/assets/drawerIcons";
import { buildUserMenu } from "@/routes/userMenu";
export default {
  name: "DrawerComponent",
  components: {
    TeckSupport,
  },
  data() {
    return {
      isAtBottom:false,
      drawer: true,
      checkResponsive: false,
      newSupport: 0,
      key: 1,
      countObj: {},
      is_customer_service: localStorage.getItem('is_customer_service') ,
      isDeveloper: localStorage.getItem("is_developer") === "1",
    };
  },
  computed: {
    // Icon color helper - gets the current theme icon color
    iconColor() {
      return this.$vuetify.theme.themes.light.iconColor1;
    },
    userMenu() {
      return buildUserMenu(this.pages, {
        isAdmin: !!localStorage["isAdmin"],
        role: String(localStorage["role"] || ""),
        isCustomerService: localStorage["is_customer_service"] == "1",
        accountType: String(localStorage["account_type"] || ""),
        isDeveloper: this.isDeveloper,
        iconColor: this.iconColor,
      });
    },
    menuEntries() {
      return this.userMenu.entries;
    },
    mini() {
      return this.$store.state.mini;
    },

    getIcons() {
      return (page) => {
        // Change color of icons 
        if (page.meta.page_name === 'طلبات الدعم الفني') {
          const fillColor = this.$store.state.newSupport > 0 ? 'rgb(1, 127, 133)' : 'white';
          return getSupportIconDynamic(fillColor);
        }

        if (page.meta.page_name === 'التذاكر المستلمة') {
          const fillColor = this.$store.state.recieved_tasks_notifications_count > 0 ? 'rgb(1, 127, 133)' : 'white';
          return getTicketsReceivedIconDynamic(fillColor);
        }

        // if (page.meta.page_name === 'محادثات العملاء') {
        //   const fillColor = this.$store.state.navbarUnreadCountNum > 0 ? 'rgb(1, 127, 133)' : 'white';
        //   return `
        //     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        //     <path d="M8.00033 18.666H18.667V15.9993H8.00033V18.666ZM8.00033 14.666H24.0003V11.9993H8.00033V14.666ZM8.00033 10.666H24.0003V7.99935H8.00033V10.666ZM2.66699 29.3327V5.33268C2.66699 4.59935 2.92833 3.97179 3.45099 3.45002C3.97366 2.92824 4.60121 2.6669 5.33366 2.66602H26.667C27.4003 2.66602 28.0283 2.92735 28.551 3.45002C29.0737 3.97268 29.3345 4.60024 29.3337 5.33268V21.3327C29.3337 22.066 29.0728 22.694 28.551 23.2167C28.0292 23.7393 27.4012 24.0002 26.667 23.9993H8.00033L2.66699 29.3327ZM6.86699 21.3327H26.667V5.33268H5.33366V22.8327L6.86699 21.3327Z" fill="${fillColor}"/>
        //     </svg>
        //   `;
        // }

        if (page.meta.page_name === 'تقيمات الخدمه' || page.meta.page_name === 'تقييمات الخدمة') {
          const fillColor = this.$store.state.rates_notifications_count > 0 ? 'rgb(1, 127, 133)' : 'white';
          return getServiceRatingsIconDynamic(fillColor);
        }

        return page.meta.icon;
      };
    },

    
    getNavBarGroupsBottomIcons() {
      return (page) => {
        // Change color of icons 
        const fillColor = this.$store.state.supportCount > 0 ? 'rgb(1, 127, 133)' : 'white';
        // Note: getSupportIcon() returns a static white icon, but we need dynamic color
        // For now, return the static icon. If dynamic color is needed, create getSupportIconDynamic variant
        return getSupportIcon();
      };
    },

    techSupport() {
      if (localStorage["isAdmin"]) {
        return true;
      } else {
        return false;
      }
    },
    filteredNavBarGroupsBottom() {
      return this.userMenu.bottom;
    },
    pages() {
      return this.$router.options.routes.filter((page) => {
        return page.meta.listed;
      });
    },
  },

  mounted() {
    window.addEventListener('scroll', this.updateScrollState);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateScrollState);
  },

  methods: {

    entryItems(entry) {
      if (Array.isArray(entry.items)) {
        return entry.items;
      }
      return [];
    },

    scrollTo() {
      if (this.isAtBottom) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      }
      this.isAtBottom = !this.isAtBottom;
    },

    updateScrollState() {
      this.isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;
    },


    ticketIconColor() {
      return this.$store.state.recieved_tasks_notifications_count > 0
        ? 'rgb(1, 127, 133)'
        : this.$vuetify.theme.themes.light.iconColor1;
    },

    redirect() {
      if (this.$route.name !== " all" && this.CurrentRole == 7) {
        this.$router.push({ name: "adminHome" });
      } else if (this.$route.name !== "all" && this.CurrentRole == 0) {
        if (localStorage.getItem("is_customer_service") === "1") {
          this.$router.push({ name: "cs_all" });
        } else {
          this.$router.push({ name: "agentHome" });
        }
      } else if (this.$route.name !== "salesManagerAll" && this.CurrentRole == 1) {
        this.$router.push({ name: "salesManagerAll" });
      } else if (this.$route.name !== "qualityAll" && this.CurrentRole == 5) {
        this.$router.push({ name: "qualityAll" });
      } else if (this.CurrentRole == 16) {
        this.$router.push({ name: "customerServiceSupervisorHome" });
      }
    },
    SimplifyNumber,
    getAllRequests() {
      Axios.get(
          `${this.$store.state.url}/v2/employee/Requests?type=count`,

        { headers: this.request_headers() }
      ).then((res) => {
        this.countObj = res.data.payload;
      });
    },
    refreshDeveloperAccess() {
      if (String(localStorage.getItem("role")) !== "7") {
        return;
      }
      Axios.get(`${this.$store.state.url}/employee/admin/google-drive/call-center/access`, {
        headers: this.request_headers(),
      })
        .then((res) => {
          const allowed = !!(res.data.payload && res.data.payload.allowed);
          localStorage.setItem("is_developer", allowed ? "1" : "0");
          this.isDeveloper = allowed;
        })
        .catch(() => {
          localStorage.setItem("is_developer", "0");
          this.isDeveloper = false;
        });
    },
    getSupportCount() {
      let newSupportRequest = [];
      Axios.post(
          `${this.$store.state.url}/employee/admin/help-desk`,
          {},
          { headers: this.request_headers() }
      ).then((res) => {
        this.$store.state.newSupport = res.data.payload.count_of_new_helpdesks;
      });
    },

    resize_app_bar() {
      if (window.matchMedia("(min-width: 900px)").matches) {
        this.$store.state.mini = !this.$store.state.mini;
      }
    },
    responsiveScreen() {
      if (window.matchMedia("(max-width: 767px)").matches) {
        this.checkResponsive = true;
      } else {
        this.checkResponsive = true;
      }
    },
  },
  async created() {
    this.CurrentRole = localStorage["role"];
    this.refreshDeveloperAccess();
    this.getAllRequests();
    this.getSupportCount();
    await this.responsiveScreen();
  },
  props: {
    supportCount: {
      required: false,
    },
  },
};
</script>

<style>

#sidebar {
  position: fixed;
  right: 20px;
  bottom: 0;
  background-color: #ffffff;
  transform: translateY(-50%);
}

.showCount {
  background: #017f85;
  position: absolute;
  width: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 37px;
  border-radius: 50%;
  font-size: 11px !important;
  left: 15px;
}
.drawer {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 24px #2d343a1a;
  opacity: 1;
}
#logo {
  display: block;
  max-height: 48px;
  margin: auto;
  text-align: center;
}
.item-text-color {
  color: v-bind($vuetify.theme.themes.light.drawertextColor) !important;
}
.d-logo-item {
  background-color: v-bind($vuetify.theme.themes.light.color1) !important;
}
i.v-icon.notranslate.mdi.mdi-chevron-down.theme--light {
  color: #fff;
}
.support-c-1 {
  margin-left: 12px;
}
.support-c-2 {
  margin: 0 10px 0px 0px !important;
}
.support-c-3 {
  margin: 0 0 0 0 !important;
}
.theme--light.v-navigation-drawer{
    overflow: unset;
}
.v-list-group .v-list-group__items {
  right: 250px;
  position: absolute;
  max-height: 35rem;
    overflow-x: auto;
    overflow-y: scroll;
}
.v-list-group--active .v-list-group__items {
    background: #3f0e40;
    max-height: 20rem;
}
</style>
